import store from "../store";
export default {
	/**
	 * Track bets
	 * @param payload = {bet_type,num_of_items,user_id,amount,message}
	 */
	bet: {
		add: function (payload) {},
		success: function (payload) {
			try {
				fbq("trackCustom", "PlaceBetMobileWeb", {
					bet_type: payload.bet_type,
					num_items: payload.num_of_items,
					user_id: payload.user_id,
					value: payload.amount,
					currency: CURRENCY,
					message: payload.message,
				});
			} catch (e) {
				console.error("Bet tracking failed");
				console.warn(e);
			}
		},
		initiate: function (payload) {
			try {
				fbq("trackCustom", "InitiateBetMobileWeb", {
					bet_type: payload.bet_type,
					num_items: payload.num_of_items,
					user_id: payload.user_id,
					value: payload.amount,
					currency: CURRENCY,
					message: payload.message,
				});
			} catch (e) {
				console.error("Bet tracking failed");
				console.warn(e);
			}
		},
		failed: function (payload) {
			try {
				fbq("trackCustom", "FailedBetMobileWeb", {
					bet_type: payload.bet_type,
					num_items: payload.num_of_items,
					user_id: payload.user_id,
					value: payload.amount,
					currency: CURRENCY,
					message: payload.message,
				});
			} catch (e) {
				console.error("Bet tracking failed");
				console.warn(e);
			}
		},
		firstTime: function (payload) {
			try {
				fbq("trackCustom", "FTPlaceBetMobileWeb", {
					bet_type: payload.bet_type,
					num_items: payload.num_of_items,
					user_id: payload.user_id,
					value: payload.amount,
					currency: CURRENCY,
					message: payload.message,
				});
			} catch (e) {
				console.error("Bet tracking failed");
				console.warn(e);
			}
		},
	},
	/**
	 * Track session stuff
	 * @param payload = {user_id,amount}
	 */
	session: {
		login: function (payload) {
			try {
				// cooladata.trackEvent('login', payload)
			} catch (e) {
				console.error("Login tracking failed");
				console.warn(e);
			}
		},
		signup: function (payload) {
			try {
				// cooladata.trackEvent('register', payload);
			} catch (e) {
				console.error("Session tracking failed");
				console.warn(e);
			}
		},
		logout: function (payload) {
			try {
				// cooladata.trackEvent('logout', payload)
			} catch (e) {
				console.error("Session tracking failed");
				console.warn(e);
			}
		},
		reset_password: function (payload) {
			try {
				// cooladata.trackEvent('reset_password', payload);
			} catch (e) {
				console.error("Session tracking failed");
				console.warn(e);
			}
		},
		deposit: {
			click: function (payload) {
				try {
					// cooladata.trackEvent('click_deposit_button', payload);
				} catch (e) {
					console.error("Deposit button tracking failed");
				}
			},
			success: function (payload) {
				try {
					fbq("trackCustom", "DepositMobileWeb", {
						user_id: payload.user_id,
						value: payload.amount,
						currency: CURRENCY,
					});
				} catch (e) {
					console.error("Deposit tracking failed");
					console.warn(e);
				}
			},
			failed: function (payload) {
				try {
					fbq("trackCustom", "DepositFailedMobileWeb", {
						user_id: payload.user_id,
						value: payload.amount,
						currency: CURRENCY,
					});
				} catch (e) {
					console.error("Deposit tracking failed");
					console.warn(e);
				}
			},
		},
		withdraw: {
			click: function (payload) {
				try {
					// cooladata.trackEvent('click_withdraw_button', payload);
				} catch (e) {
					console.error("Withdraw button tracking failed");
				}
			},
			success: function (payload) {
				try {
					fbq("trackCustom", "WithdrawMobileWeb", {
						user_id: payload.user_id,
						value: payload.amount,
						currency: CURRENCY,
					});
				} catch (e) {
					console.error("Withdraw tracking failed");
					console.warn(e);
				}
			},
			failed: function (payload) {
				try {
					fbq("trackCustom", "WithdrawFailedMobileWeb", {
						user_id: payload.user_id,
						value: payload.amount,
						currency: CURRENCY,
					});
				} catch (e) {
					console.error("Withdraw tracking failed");
					console.warn(e);
				}
			},
		},
		betslip: {
			add: function (payload) {
				try {
					// cooladata.trackEvent('add_to_betslip', payload);
				} catch (e) {
					console.error("Add to betslip tracking failed", e);
				}
			},
			remove: function (payload) {
				try {
					// cooladata.trackEvent('remove_from_betslip', payload);
				} catch (e) {
					console.error("Remove from betslip tracking failed", e);
				}
			},
			clear: function (payload) {
				try {
					payload.app_name = "MOBILE_WEB";
					payload.profile_id = store.getters.user.id;
					// cooladata.trackEvent('clear_all_bets', payload);
				} catch (e) {
					console.error("Clear bet tracking failed", e);
				}
			},
			place: function (payload) {
				try {
					payload.app_name = "MOBILE_WEB";
					payload.profile_id = store.getters.user.id;
					payload.user_alternative_id = store.getters.user.id;
					// cooladata.trackEvent('place_bet', payload);
				} catch (e) {
					console.error("Place bet tracking failed", e);
				}
			},
		},
	},
	page: {
		view: function (payload) {},
	},
	stream: {
		watch(payload) {
			try {
				fbq("trackCustom", "WatchLiveStreamMobile", {
					provider: payload.provider,
					event: payload.event,
					user_id: payload.user_id,
				});
			} catch (e) {
				console.error("LiveStream:: watch live tracking failed");
				console.warn(e);
			}
		},
	},
};
